function r(r, n) {
  (null == n || n > r.length) && (n = r.length);
  for (var t = 0, e = Array(n); t < n; t++) e[t] = r[t];
  return e;
}
function n(r, n, t, e, o, u, i) {
  try {
    var a = r[u](i),
      l = a.value;
  } catch (r) {
    t(r);
    return;
  }
  a.done ? n(l) : Promise.resolve(l).then(e, o);
}
function t(r) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (o, u) {
      var i = r.apply(t, e);
      function a(r) {
        n(i, o, u, a, l, "next", r);
      }
      function l(r) {
        n(i, o, u, a, l, "throw", r);
      }
      a(void 0);
    });
  };
}
function e(n) {
  return function (n) {
    if (Array.isArray(n)) return r(n);
  }(n) || function (r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
  }(n) || function (n, t) {
    if (n) {
      if ("string" == typeof n) return r(n, t);
      var e = Object.prototype.toString.call(n).slice(8, -1);
      if ("Object" === e && n.constructor && (e = n.constructor.name), "Map" === e || "Set" === e) return Array.from(e);
      if ("Arguments" === e || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e)) return r(n, t);
    }
  }(n) || function () {
    throw TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}
function o(r, n) {
  var t,
    e,
    o,
    u,
    i = {
      label: 0,
      sent: function sent() {
        if (1 & o[0]) throw o[1];
        return o[1];
      },
      trys: [],
      ops: []
    };
  return u = {
    next: a(0),
    throw: a(1),
    return: a(2)
  }, "function" == typeof Symbol && (u[Symbol.iterator] = function () {
    return this;
  }), u;
  function a(u) {
    return function (a) {
      return function (u) {
        if (t) throw TypeError("Generator is already executing.");
        for (; i;) try {
          if (t = 1, e && (o = 2 & u[0] ? e.return : u[0] ? e.throw || ((o = e.return) && o.call(e), 0) : e.next) && !(o = o.call(e, u[1])).done) return o;
          switch (e = 0, o && (u = [2 & u[0], o.value]), u[0]) {
            case 0:
            case 1:
              o = u;
              break;
            case 4:
              return i.label++, {
                value: u[1],
                done: !1
              };
            case 5:
              i.label++, e = u[1], u = [0];
              continue;
            case 7:
              u = i.ops.pop(), i.trys.pop();
              continue;
            default:
              if (!(o = (o = i.trys).length > 0 && o[o.length - 1]) && (6 === u[0] || 2 === u[0])) {
                i = 0;
                continue;
              }
              if (3 === u[0] && (!o || u[1] > o[0] && u[1] < o[3])) {
                i.label = u[1];
                break;
              }
              if (6 === u[0] && i.label < o[1]) {
                i.label = o[1], o = u;
                break;
              }
              if (o && i.label < o[2]) {
                i.label = o[2], i.ops.push(u);
                break;
              }
              o[2] && i.ops.pop(), i.trys.pop();
              continue;
          }
          u = n.call(r, i);
        } catch (r) {
          u = [6, r], e = 0;
        } finally {
          t = o = 0;
        }
        if (5 & u[0]) throw u[1];
        return {
          value: u[0] ? u[1] : void 0,
          done: !0
        };
      }([u, a]);
    };
  }
}
function u(r) {
  var n,
    u,
    i,
    a,
    l,
    c,
    f = (u = t(function () {
      var n;
      return o(this, function (t) {
        switch (t.label) {
          case 0:
            return n = c, i = l, l = null, c = null, [4, r.apply(void 0, e(n))];
          case 1:
            return a.apply(void 0, [t.sent()]), i = null, c && f(), [2];
        }
      });
    }), function () {
      return u.apply(this, arguments);
    }),
    s = function s() {
      for (var r = arguments.length, n = Array(r), t = 0; t < r; t++) n[t] = arguments[t];
      return c || (l = new Promise(function (r) {
        return a = r;
      })), c = n, l;
    },
    p = (n = t(function () {
      var n,
        t,
        u,
        a,
        l = arguments;
      return o(this, function (o) {
        switch (o.label) {
          case 0:
            for (t = Array(n = l.length), u = 0; u < n; u++) t[u] = l[u];
            if (c && !i) return f(), [2];
            if (i) return [2, s.apply(void 0, e(t))];
            return [4, i = r.apply(void 0, e(t))];
          case 1:
            return a = o.sent(), i = null, c && p(), [2, a];
        }
      });
    }), function () {
      return n.apply(this, arguments);
    });
  return p;
}
export { u as unconcurrent };